var SearchResultsViewEnhanced = Backbone.View.extend({
  events: {
    "click [data-filter]": "processFilterClick",
    "click [data-filter-clear]": "processFilterClearClick",
    "change [data-filter-range]": "processFilterClick",
    "click [data-filter-reset-key]": "processFilterResetKeyClick",
    filtersUpdate: "processFilterClick",
    resultsUpdate: "processLoading",
    "click [data-filter-range-preset]": "processRangePreset"
  },

  setDefaults: function() {
    this.viewsInitialized = false;

    this.templates = {
      messagesTemplate: ""
    };

    this.statusRetry = 0;

    this.activeRequests = 0;

    this.activeRequestTypes = {
      filters: false,
      statusCheck: false
    };

    this.statusCheck = null;
    this.searchTimeout = null;
    this.filterDelay = null;
  },

  processRangePreset: function(event) {
    var data = $(event.currentTarget).data("filterRangePreset");

    this.$('[data-range-slider="min"]').val(data.min);
    this.$('[data-range-slider="max"]').val(data.max);
    this.$("[data-range-slider]").trigger("change");
  },

  processFilterResetKeyClick: function(event) {
    this.FilterView.resetFilterKey(event);

    this.StateModel.set({
      filters: this.FilterView.getSelectedFilters()
    });

    this.loadFiltersSummary();
  },

  processFilterClick: function() {
    this.StateModel.set({
      filters: this.FilterView.getSelectedFilters()
    });

    $("[data-filter-range-preset]").removeClass("is-active");
    $(
      "[data-filter-range-id=" +
        this.StateModel.get("filters")["search"].duration_min +
        this.StateModel.get("filters")["search"].duration_max +
        "]"
    ).addClass("is-active");

    this.loadFiltersSummary();
  },

  processFilterClearClick: function() {
    this.FilterView.resetFilters();

    this.StateModel.set({
      filters: {}
    });

    this.loadFiltersSummary();
  },

  messages: {
    hasErrors: false,
    hasMessages: false,

    responseMessages: {
      fault: [],
      general: []
    },
    ajaxFailed: false,
    filterLoadingFailed: false,
    statusCheckFailed: false
  },

  clearMessages: function() {
    this.hasMessages = false;
    this.messages = {
      hasErrors: false,
      hasMessages: false,

      responseMessages: {
        fault: [],
        general: []
      },
      ajaxFailed: false,
      filterLoadingFailed: false,
      statusCheckFailed: false
    };
  },

  render: function() {
    if (!this.activeRequests) {
      this.$("[data-messages]").html(
        this.templates.messagesTemplate(this.messages)
      );

      this.clearMessages();
    }
  },

  initViews: function() {
    this.FilterView.setSelectedFilters(this.StateModel.get("filters"));

    if (this.FilterView.isInitialized) {
      this.render();
      this.viewsInitialized = true;
    } else {
      this.loadFiltersSummary();
    }
  },

  runFailure: function() {
    this.FilterView.stopFilterLoading();
    this.render();
  },

  processResponseMessages: function(response) {
    if (response.messages.fault.length) {
      this.messages.hasErrors = true;
      var currentFault = this.messages.responseMessages.fault;
      var newFault = response.messages.fault;

      this.messages.responseMessages.fault = currentFault.concat(newFault);
    }

    if (response.messages.general.length) {
      this.messages.hasMessages = true;

      var currentGeneral = this.messages.responseMessages.general;
      var newGeneral = response.messages.general;

      this.messages.responseMessages.fault = currentGeneral.concat(newGeneral);
    }
  },

  loadFiltersSummary: function() {
    var filters = this.StateModel.getFilters();

    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.selectionSummaryFilters,

      data: {
        st: this.settings.token,
        filters: filters.search
      },

      beforeSend: () => {
        if (this.activeRequestTypes.filters) {
          return false;
        }

        this.$("[data-view-results]").attr("disabled", true);
        this.$("[data-total-count-container]").addClass("is-loading");
        this.FilterView.startFilterLoading();
        this.FilterView.setSelectedFilters(this.StateModel.get("filters"));

        this.activeRequestTypes.filters = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.filters = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.data.processing) {
          this.queueStatusCheck();
        } else if (response.data.session_expired) {
          this.expireSession();
        } else if (response.success === true) {
          this.$("[data-total-count]").html(response.data.total_count);
          this.$("[data-total-count-container]").removeClass("is-loading");
          this.FilterView.render(response.data.filters);

          var totalCount = parseInt(
            response.data.total_count.replace(/,/g, "")
          );
          var warningMessage = $(".search-enhanced").find(".message-warning");

          if (totalCount <= 500) {
            warningMessage.addClass("is-hidden");
            this.$("[data-view-results]").removeAttr("disabled");
          } else if (totalCount <= 2000) {
            this.$("[data-view-results]").removeAttr("disabled");
            warningMessage.removeClass("is-hidden");
          } else {
            warningMessage.removeClass("is-hidden");
          }
        }
      },

      error: () => {
        this.activeRequestTypes.filters = false;
        this.activeRequests--;

        this.messages.hasErrors = true;
        this.messages.filterLoadingFailed = true;
      }
    });
  },

  expireSession: function() {
    this.$("[data-expired-session-notice]")
      .component()
      .open();
  },

  extendSearchSession: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.sessionExtend,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
      },

      success: () => {
        this.searchTimeout = setTimeout(() => {
          this.expireSession();
        }, 1740000);
      }
    });
  },

  queueStatusCheck: function() {
    if (this.statusCheck) {
      clearTimeout(this.statusCheck);
    }

    setTimeout(() => {
      this.checkStatus();
    }, this.settings.requestDelay);
  },

  checkStatus: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.searchStatus,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (
          this.activeRequestTypes.statusCheck ||
          (this.statusRetry >= 99 && !this.viewsInitialized)
        ) {
          return false;
        } else {
          this.statusRetry++;
        }

        this.activeRequestTypes.statusCheck = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.statusCheck = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.success === true) {
          if (response.data.processing === true || !response.data.completed) {
            this.queueStatusCheck();
          }

          if (response.data.ready === true) {
            if (!this.viewsInitialized) {
              this.initViews();
            }

            if (!this.FilterView.isInitialized) {
              this.loadFiltersSummary();
            }
          }

          if (response.data.completed === true) {
            Backbone.Events.trigger("statusCheckComplete");
          }
        } else if (response.data.session_expired) {
          this.expireSession();
        } else {
          if (response.data.completed === true) {
            this.runFailure();
            Backbone.Events.trigger("statusCheckComplete");
          }

          this.messages.hasErrors = true;
          this.messages.statusCheckFailed = true;
        }
      },

      error: response => {
        this.activeRequestTypes.statusCheck = false;
        this.activeRequests--;

        this.hasErrors = true;
        this.messages.ajaxFailed = true;
        this.runFailure();
      }
    });
  },

  initialize: function(options) {
    this.setDefaults();

    this.templates.messagesTemplate = Handlebars.compile(
      this.$("[data-messages-template]").length
        ? this.$("[data-messages-template]").html()
        : ""
    );

    this.FilterView = options.FilterView;
    this.StateModel = options.StateModel;

    if (this.$el.data("settings")) {
      this.settings = $.extend(
        true,
        this.settings,
        JSON.parse(this.$el.data("settings"))
      );
    }

    this.StateModel.set(
      JSON.parse(window.sessionStorage.getItem(this.settings.token))
    );

    this.StateModel.on("change", StateModel => {
      window.sessionStorage.setItem(
        this.settings.token,
        JSON.stringify(StateModel)
      );
    });

    if (this.settings.token) {
      this.initViews();
      this.checkStatus();
    } else {
      this.runFailure();
    }
  }
});

module.exports = SearchResultsViewEnhanced;
